import { HostListener } from "@angular/core";
import { OnInit, Input } from "@angular/core";
import { Directive } from "@angular/core";

@Directive({
  selector: "[appResleerphone]",
  exportAs: "reslerPhone"
})
export class ResleerphoneDirective implements OnInit {
  ngOnInit(): void {
    // console.log("i am now in the directive of phone");
  }
  constructor() {}

  @HostListener("input", ["$event"])
  onKeyDown(event: KeyboardEvent) {
    // const input = event.target as HTMLInputElement;
    // // console.log(input.value, " now is inputting");
    // // 这个里面获取的值是当前input.里面所有的值, 也就是存在于input里面的所有数据

    // let trimmed = input.value.replace(/\s+/g, '');
    // if (trimmed.length > 18) {
    //   trimmed = trimmed.substr(0, 16);
    // }

    // const numbers = [];
    // for (let i = 0; i < trimmed.length; i += 3) {
    //   numbers.push(trimmed.substr(i, 3));
    // }

    // input.value = numbers.join(' ');
  }
}



// WEBPACK FOOTER //
// ./src/app/tooltip/resleerphone.directive.ts